// extracted by mini-css-extract-plugin
export default {"container":"wo-manufacturer-match_container__XiKq9","modalOverlay":"wo-manufacturer-match_modalOverlay__mmSKR","modalContent":"wo-manufacturer-match_modalContent__pzv1Z"};